// extracted by mini-css-extract-plugin
export const accountLinkageForm = "LinkageForm__accountLinkageForm__GMZc8";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttonWrapper = "LinkageForm__buttonWrapper__J58Os";
export const errorWrapper = "LinkageForm__errorWrapper__IDrWs";
export const fieldList = "LinkageForm__fieldList__Ot7kf";
export const fieldListItem = "LinkageForm__fieldListItem__R-f1d";
export const fieldsContainer = "LinkageForm__fieldsContainer__tY23H";
export const forgetPassword = "LinkageForm__forgetPassword__tzM2A font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const instructions = "LinkageForm__instructions__P13ib font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const logo = "LinkageForm__logo__LwLF0";
export const medium = "500";
export const name = "LinkageForm__name__2a-vX font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const phoneNumber = "LinkageForm__phoneNumber__q9jDP font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const regular = "400";
export const sans = "'sans'";
export const secureIconWrapper = "LinkageForm__secureIconWrapper__QzH1Y";
export const secureLink = "LinkageForm__secureLink__IWjv4 font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const semibold = "600";
export const serif = "'serif'";
export const timeoutCopy = "LinkageForm__timeoutCopy__NyCxJ";
export const timeoutValue = "LinkageForm__timeoutValue__ZH2Rf";
export const timeoutWrapper = "LinkageForm__timeoutWrapper__5BeYu font-faces__sansRegular__c8KXl font-faces__sans__uCf65";